import type { SearchType } from './useMobileSearchAPI'

/**
 * Canonical display labels for each mobile search type. Single source of truth
 * shared by the search-type dropdown, the search state, and the
 * filter-aware option builder.
 */
export const SEARCH_TYPE_LABELS: Record<SearchType, string> = {
  fb_company: 'First Bite Company',
  fb_location: 'First Bite Location',
  custom_company: 'Custom Company',
  custom_location: 'Custom Location',
}

/** All search-type options, in display order. */
export const ALL_SEARCH_TYPE_OPTIONS: { value: SearchType; label: string }[] = (
  ['fb_company', 'fb_location', 'custom_company', 'custom_location'] as const
).map((value) => ({ value, label: SEARCH_TYPE_LABELS[value] }))
